import React from 'react';
import PropTypes from 'prop-types';
import Navigation from './Navigation';

class Header extends React.Component {

  static propTypes = {
    showRefreshing: PropTypes.func.isRequired,
    hideRefreshing: PropTypes.func.isRequired,
  };

  render() {
    const { showRefreshing, hideRefreshing } = this.props;

    return (
      <header className="bg-dark py-4">
        <div className="container">
          <Navigation
            showRefreshing={showRefreshing}
            hideRefreshing={hideRefreshing}
          />
        </div>
      </header>
    );
  }

}

export default Header;
